<template>
	<aside class="d-flex side-nav" ref="aside">
		<nav class="navbar-aside py-3 px-2 d-flex flex-column align-items-center" ref="navbar-aside">

			<ul class="nav nav-body w-100 flex-column">
				<li v-for="item in menuItems" :key="item.id" class="nav-item"
					:class="{ 'active': $route.path === item.path }">

					<router-link class="nav-link" :to="item.path" :title="item.label">
						<component v-if="item.iconType === 'component'" :is="item.icon" />
						<img v-else :src="item.icon" width="24" height="24">
						<p class="mb-0">{{ item.label }}</p>
					</router-link>
				</li>
			</ul>
		</nav>

		<div class="splitter d-flex flex-column justify-content-center align-items-center"
			:class="{ 'is-expanded': !isBarMinimized }" @mousedown.prevent="startResize">
			<div class="handle w-100 h-100"></div>
			<svg class="arrow" id="toggleSizeAsideNav" @click.stop="toggleNavBar" version="1.1"
				xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
				<path d="M9.984 6l6 6-6 6-1.406-1.406 4.594-4.594-4.594-4.594z"></path>
			</svg>
		</div>
	</aside>
</template>


<script>

	export default {

		data () {
			return {
				isBarMinimized: true, // Árvores
				originalWidth: 70,
				originalX: 0,
				originalMouseX: 0,
				maxWidth: 211,
				minWidth: 0,
				refNav: "navbar-aside"
			};
		},

		props: {
			hidden: Boolean
		},

		watch: {
			hidden: "setHiddenState"
		},


		computed: {
			menuItems () {
				const getImg = name => require(`../assets/icons/${name}.png`);

				return [
					{
						id: "ConteudoPrincipal",
						path: "/",
						label: "Dashboard",
						iconType: "component",
						icon: "DashboardIcon"
					},
					{
						id: "ConteudoCardLocalizacao",
						path: "/infraestrutura-ucg",
						label: "Infraestrutura UCG",
						iconType: "img",
						icon: this.$route.path === "/infraestrutura-ucg" ? getImg("UCG_ativo") : getImg("UCG")
					},
					{
						id: "ConteudoCardSystem",
						path: "/infraestrutura-mmi",
						label: "Infraestrutura MMI",
						iconType: "component",
						icon: "ServerIcon"
					},
					{
						id: "ConteudoCardModulos",
						path: "/modulos",
						label: "Módulos MMI",
						iconType: "img",
						icon: this.$route.path === "/modulos" ? getImg("Modulo_MMI_ativo") : getImg("Modulo_MMI")
					},
					{
						id: "ConteudoCardMachines",
						path: "/machines",
						label: "Máquinas",
						iconType: "component",
						icon: "CpuIcon"
					}
				];
			}
		},

		methods: {
			startResize (e) {
				const element = this.$refs[this.refNav];

				const resize = e => {
					const width = this.originalWidth + (e.pageX - this.originalMouseX);
					if (width > this.maxWidth) {
						element.style.width = this.maxWidth + "px";
					} else {
						element.style.width = width + "px";
					}

					this.isBarMinimized = width <= this.minWidth;
				};

				const stopResize = () => {
					window.removeEventListener("mousemove", resize);
					window.removeEventListener("mouseup", stopResize);
					this.$emit("resize", parseInt(window.getComputedStyle(element).width) + 2);
				};

				this.originalWidth = parseFloat(getComputedStyle(element, null).getPropertyValue("width").replace("px", ""));
				this.originalX = element.getBoundingClientRect().left;
				this.originalMouseX = e.pageX;
				window.addEventListener("mousemove", resize);
				window.addEventListener("mouseup", stopResize);
			},

			toggleNavBar () {
				const element = this.$refs[this.refNav];

				this.originalWidth = parseFloat(getComputedStyle(element, null).getPropertyValue("width").replace("px", ""));
				element.classList.add("animw");

				if (this.originalWidth > this.minWidth) {
					// Minimize
					element.style.width = this.minWidth + "px";
					this.isBarMinimized = true;
				} else {
					// Maximize
					element.style.width = this.maxWidth + "px";
					this.isBarMinimized = false;
				}

				setTimeout(() => element.classList.remove("animw"), 300);
			},

			maximize () {
				const element = this.$refs[this.refNav];
				element.style.width = this.maxWidth + "px";
				this.isBarMinimized = false;
			},

			setHiddenState () {
				const aside = this.$refs.aside;
				if (this.hidden) {
					// Oculta barra deslizando-a para a esquerda
					aside.style.transform = "translateX(-100%) translateX(-30px)";
				} else {
					// Mostra barra deslizando-a para a direita
					aside.style.transform = "translateX(0)";
				}
			}


		},

		mounted () {
			const element = this.$refs[this.refNav];
			this.minWidth = parseFloat(getComputedStyle(element, null).getPropertyValue("min-width").replace("px", ""));
			this.setHiddenState();
		}

	};
</script>

<style scoped>
.feather-dashboard {
	fill: currentColor !important;
}

.navbar-aside {
	width: 70px;
	flex-shrink: 0;
}

.navbar-aside .nav {
	display: block;
}

.splitter svg path {
	transition: transform 0.3s ease-in-out;
}

.splitter.is-expanded svg path {
	transform: scaleX(-1) translateX(-100%);
}

nav::-webkit-scrollbar {
	width: 3px;
	height: 3px;
}

nav::-webkit-scrollbar-track {
	background: #6dcff6;
}

nav::-webkit-scrollbar-thumb {
	background-color: #fff;
	border-radius: 20px;
}

.side-nav {
	position: absolute;
	z-index: 1000;
	transition: .3s ease-in-out;
	height: 100%;
	overflow: visible;


}

.side-nav nav {
	box-shadow: 0px 10px 10px rgba(0, 0, 0, 0.3);

	/* font-family: 'Open Sans', sans-serif; */
	background-color: #6dcff6;

	/* TODO: verify necessity */
	flex: 0 0 auto;
	white-space: nowrap;
	/* --- */
	height: 100%;
	position: relative;
	z-index: 1;

	/* max-width: 217px; */
	min-width: 70px;

	transition: box-shadow .6s;
}

.side-nav nav .nav-body .nav-item p {
	font-weight: 500
}

.side-nav._hide {
	transform: translateX(-100%);
}

.side-nav .compressed {
	width: 70px;
}

.side-nav .expanded {
	width: 100%;
}

.side-nav nav .nav-header img,
.side-nav nav .nav-footer img {
	width: 100%;
	max-width: 80px;
	display: block;
}

.side-nav nav .nav-body .nav-item {
	border-radius: 10px;
	cursor: pointer;
	transition: .3s;
	width: 100%;
	color: #fff;
}

.side-nav nav .nav-body .nav-item:hover,
.nav-item.hover {
	background-color: rgba(0, 0, 0, 0.08);
}

.side-nav nav .nav-body .nav-item svg {
	min-width: 24px;
	max-width: 32px;

}

.side-nav nav .nav-body .nav-item p {
	color: white;
	font-family: var(--fonte-extra-bold);
}

.side-nav nav .nav-body .nav-item.active {
	background-color: white;
	color: #6DCFF6;
	box-shadow: 0 0 20px rgba(0, 0, 0, 0.08);

}

.side-nav nav .nav-body .nav-item.active p {
	color: #6dcff6;
	font-weight: 900;
}

.side-nav nav .nav-body .nav-item .dropdown-toggle::after {
	display: none !important
}

.side-nav nav .nav-body .nav-item .dropdown-toggle::after {
	color: white;
}

.side-nav nav .nav-body .nav-link {
	display: flex;
	align-items: center;
	width: 100%;
	color: currentColor;
}

.side-nav nav .nav-body p {
	opacity: 1;
	padding-left: 10px;
	overflow: hidden;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	white-space: nowrap;
}

.side-nav nav .nav-body hr {
	display: block;
	padding: .5rem 1rem;
	/* width: 20%; */
	border-top: 2px solid rgba(255, 255, 255, .4);
}

.side-nav nav .nav-footer {
	position: relative;
	overflow: hidden;
	/* height: 50px; */
}

.side-nav nav .nav-footer div {
	border-right: 2px solid rgba(255, 255, 255, 0.5);
	height: 70%;
}

.side-nav nav:hover~.splitter,
.splitter:hover,
.splitter:active {
	padding: 8px;
}

.splitter {
	flex: 0 0 auto;
	transition: .5s;
	padding: 0px;
	/* background-color: #e6e7e8; */
	/* background-color: white; */
	cursor: col-resize;
	position: relative;
	z-index: 1001;
	height: 100%;
}

.splitter .handle,
.splitter .arrow {
	position: absolute;
}

.splitter .arrow {
	width: 200%;
	height: 40px;
	cursor: pointer;
	fill: dimgray;
	transition: width .6s, fill .3s;
	border-radius: 10px;
	background-color: white;
	transform: translateX(-25%);
	box-shadow: 0 0 10px rgba(0, 0, 0, .05);
}

.splitter .arrow:hover,
.splitter .arrow.active {
	fill: #6dcff6;
}

.splitter .arrow.expanded {
	transform: translateX(-25%) rotate(180deg);
}
</style>